import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useLicencePayment } from "src/Utils/Hooks/Payments/usePayment";
import { useResubscribe } from "src/Utils/Hooks/Payments/useResubscribe";
import ResubscribeInfo from "./ResubscribeInfo";

interface IResubscribe {
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    priceId: string;
    isSubscriptionExpired: boolean;
}

const Resubscribe: React.FC<IResubscribe> = ({clinicId, setInfo, updatePageLoader, priceId, isSubscriptionExpired}) => {
    const { t } = useTranslation();
    const { checkoutUrl, createLicensePaymentPage, reqestLoading, reqestError} = useLicencePayment();
    const {reqestResponse, reqestError: resubscribeError, reqestLoading: resubscribeLoading, resubscribeSubscription} = useResubscribe();
    
    useEffect(() => {
        updatePageLoader(reqestLoading) 
    }, [reqestLoading, updatePageLoader]);

    useEffect(() => {
        updatePageLoader(resubscribeLoading) 
    }, [resubscribeLoading, updatePageLoader]);

    useEffect(() => {
        if (checkoutUrl) {
            window.open(checkoutUrl, '_self');
        }
    }, [checkoutUrl]);

    useEffect(() => {
        if(reqestResponse){
            setInfo('License subscription resubscribed successfully.', InfoMessageType.success);
        }
    }, [reqestResponse, setInfo]);

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(reqestError, InfoMessageType.error);
        } 
    },[reqestError, setInfo])

    useEffect(() => {
        if (resubscribeError !== '') {
            setInfo(resubscribeError, InfoMessageType.error);
        } 
    },[resubscribeError, setInfo])

    // Shown only for the expired path, which is the one that goes through checkout and so the only
    // one that can carry arrears. A subscription still live at the provider is resumed in place,
    // with nothing outstanding to confirm.
    const [showDues, setShowDues] = useState<boolean>(false);

    const handleResubscribe = () => {
        if (!isSubscriptionExpired) {
            resubscribeSubscription(clinicId);
            return;
        }

        // Ask what is owed before sending the customer anywhere. The dialog closes itself and calls
        // straight through when there are no arrears, so a clinic that owes nothing sees exactly
        // what it saw before this existed.
        setShowDues(true);
    }

    const goToCheckout = useCallback(() => {
        setShowDues(false);
        createLicensePaymentPage(priceId, clinicId);
    }, [createLicensePaymentPage, priceId, clinicId]);

    return(
        <>
            <div onClick={handleResubscribe} className="dropdown-item" id="resubscribe">
                {t('Resubscribe')}
            </div>
            {showDues && (
                <ResubscribeInfo
                    clinicId={clinicId}
                    priceId={priceId}
                    onClose={() => setShowDues(false)}
                    setInfo={setInfo}
                    updatePageLoader={updatePageLoader}
                    onConfirm={goToCheckout}
                />
            )}
        </>
    );
}

export default Resubscribe;